/* eslint-disable ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';

export default class EditVotingRightsController extends Controller {
  @action
  setContactNum(value) {
    this.contactNum = value;
  }

  @tracked contactNum = 1;

  get title() {
    return `Edit Voting Rights (Contact ${this.contactNum})`;
  }

  get contactPos() {
    let positions = ['First', 'Second', 'Third'];

    return positions[this.contactNum - 1];
  }

  @computed('model.fieldGroups')
  get contactSequence() {
    let contacts = this.model.fieldGroups.find(
      (group) => group.key === 'contacts',
    );
    if (isEmpty(contacts)) {
      // No "Contacts" group/tab.  Default to first tab.
      return 0;
    }

    let index = this.model.fieldGroups
      // Not rendered as a tab.
      .filter((group) => group.key !== 'medicalCondition')
      // Sorted by sequence (only) in person-form.
      .sort((a, b) =>
        a.sequence > b.sequence ? 1 : a.sequence < b.sequence ? -1 : 0,
      )
      .indexOf(contacts); // Tabs are keyed by index, not sequence.

    if (index === -1) {
      // "Contacts" group/tab not found.  Default to first tab.
      return 0;
    }
    return index;
  }

  @computed('contactNum', 'model.people.[]')
  get rows() {
    // primaryContacts array is zero-based, but this.contactNum is human-friendly (1-based).
    let pos = this.contactNum - 1;
    return this.model.people.map((learner) => {
      let caregiver = null;
      let address1 = null;
      let voting = null;
      let contact = learner.learner.primaryContacts[pos];
      if (!isEmpty(contact) && !isEmpty(contact.get('caregiverId'))) {
        caregiver = this.model.caregivers.find(
          (item) => item.id === contact.get('caregiverId'),
        );
        if (!isEmpty(caregiver)) {
          address1 = caregiver.fields.get('nzMOE:address1.value');
          voting = contact.fields.get('nzMOE:botVoting.value');
        }
      }
      return {
        learner,
        contact,
        caregiver,
        address1,
        voting,
      };
    });
  }
}
